import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getSolutionById } from '../api';
import './ProductDetailPage.css';

export default function SolutionDetailPage({ onGetSolution }) {
  const { solutionId } = useParams();
  const [solution, setSolution] = useState(null);
  const [tab, setTab] = useState('solution');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getSolutionById(solutionId)
      .then(data => { setSolution(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [solutionId]);

  if (loading) return <div className="loading-center">加载中...</div>;
  if (!solution) return <div className="loading-center">方案不存在</div>;

  const products = solution.products || [];
  const category = solution.category;

  const tabs = [
    { key: 'solution', label: '解决方案' },
    { key: 'pain', label: '行业痛点' },
    { key: 'value', label: '落地价值' },
    ...(products.length > 0 ? [{ key: 'products', label: `支撑产品 (${products.length})` }] : []),
  ];

  return (
    <>
      <Helmet>
        <title>{solution.seo_title || solution.name} - 河南和正网络科技有限公司</title>
        <meta name="description" content={solution.seo_description || solution.value_proposition || solution.name} />
        {solution.seo_keywords && <meta name="keywords" content={solution.seo_keywords} />}
      </Helmet>

      <div className="page-banner" style={{
        background: solution.cover_image
          ? `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)),url(${solution.cover_image}) center/cover`
          : 'linear-gradient(135deg,#1a56db,#0d3a8e)'
      }}>
        <div className="container">
          <h1>{solution.name}</h1>
          <nav className="breadcrumb">
            <Link to="/">首页</Link> <span>›</span>
            <span>行业方案</span> <span>›</span>
            {category && <Link to={`/category/${category.id}`}>{category.name}</Link>}
            {category && <span>›</span>}
            <span>{solution.name}</span>
          </nav>
        </div>
      </div>

      {/* Tab 导航 */}
      <div className="detail-tabs-bar">
        <div className="container">
          {tabs.map(t => (
            <button
              key={t.key}
              className={`detail-tab${tab === t.key ? ' active' : ''}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <section className="section">
        <div className="container product-detail-layout">
          <div className="product-main">
            {/* 解决方案 */}
            {tab === 'solution' && (
              <div className="detail-overview">
                {solution.value_proposition && (
                  <p className="product-summary">{solution.value_proposition}</p>
                )}
                {solution.solution_content && (
                  <div className="article-content" dangerouslySetInnerHTML={{ __html: solution.solution_content }} />
                )}
                {!solution.solution_content && !solution.value_proposition && (
                  <p style={{color:'var(--text-secondary)'}}>暂无详细方案内容</p>
                )}
              </div>
            )}

            {/* 行业痛点 */}
            {tab === 'pain' && (
              <div className="detail-overview">
                {solution.pain_points ? (
                  <div className="article-content" dangerouslySetInnerHTML={{ __html: solution.pain_points }} />
                ) : (
                  <p style={{color:'var(--text-secondary)'}}>暂无行业痛点描述</p>
                )}
              </div>
            )}

            {/* 落地价值 */}
            {tab === 'value' && (
              <div className="detail-overview">
                {solution.value_proposition ? (
                  <div className="article-content" dangerouslySetInnerHTML={{ __html: solution.value_proposition }} />
                ) : (
                  <p style={{color:'var(--text-secondary)'}}>暂无落地价值描述</p>
                )}
              </div>
            )}

            {/* 支撑产品 */}
            {tab === 'products' && (
              <div className="product-grid">
                {products.map(p => (
                  <Link key={p.id} to={`/product/${p.id}`} className="product-card">
                    <div className="product-cover">
                      {p.cover_image
                        ? <img src={p.cover_image} alt={p.name} loading="lazy" />
                        : <div className="cover-placeholder">PRODUCT</div>
                      }
                    </div>
                    <div className="product-body">
                      <h3>{p.name}</h3>
                      <p>
                        <span className={`badge ${p.product_category_type === 'hardware' ? 'badge-purple' : 'badge-blue'}`}>
                          {p.product_category_type === 'hardware' ? '硬件产品' : '软件产品'}
                        </span>
                      </p>
                      <span className="btn btn-outline btn-sm">查看产品</span>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>

          <aside className="product-sidebar">
            <div className="sidebar-card">
              <h4>获取方案咨询</h4>
              <p>专业顾问为您提供定制化解决方案</p>
              <button className="btn btn-primary" style={{width:'100%',marginTop:16}} onClick={onGetSolution}>
                立即获取方案
              </button>
            </div>

            {/* 关联产品快速导航 */}
            {products.length > 0 && (
              <div className="sidebar-card" style={{marginTop:16}}>
                <h4 style={{marginBottom:12}}>支撑产品 ({products.length})</h4>
                {products.map(p => (
                  <Link key={p.id} to={`/product/${p.id}`} className="product-item" style={{marginBottom:6}}>
                    <span className="product-dot" />
                    {p.name}
                  </Link>
                ))}
              </div>
            )}
          </aside>
        </div>
      </section>
    </>
  );
}
